// 必要なコンポーネントやライブラリをインポート
import UserFrame from "../organisms/UserFrame"; // ユーザー用のフレームコンポーネント
import { Container, Box, Typography, Grid, Button } from '@mui/material'; // Material-UIのコンポーネント

/** 
 * ユーザー問い合わせテンプレートコンポーネント
 * 問い合わせフォームを表示するUIを提供
 */
const UserContactTemplate = () => {

    return (
        // ユーザー専用フレームで全体をラップ
        <UserFrame title=''> {/* titleプロパティは空の状態 */}
            {/* コンテンツの最大幅を`sm`（スモールサイズ）に設定 */}
            <Container maxWidth='sm'>
                {/* 問い合わせフォーム全体を囲むボックス */}
                <Box sx={{ height: '600px', width: '100%', padding: '20px' }}>
                    {/* グリッドを使用してフォームコンポーネントを縦方向に配置 */}
                    <Grid 
                        container 
                        alignItems="center" // 中央揃え
                        direction="column" // 縦方向に配置
                    >
                        {/* フォームフィールドを含むボックス */}
                        <Box>
                            {/* ログインID入力欄 */}
                            <Typography>
                                Login ID
                            </Typography>
                            <input type="text" size={50} /> {/* テキスト入力フィールド */}

                            {/* タイトル入力欄 */}
                            <Typography sx={{ paddingTop: '10px' }}>
                                Title
                            </Typography>
                            <input type="text" size={50} /> {/* テキスト入力フィールド */}

                            {/* メッセージ入力欄 */}
                            <Typography sx={{ paddingTop: '10px' }}>
                                Message
                            </Typography>
                            <textarea rows={20} cols={48} maxLength={500}/> {/* テキストエリア */}
                        </Box>

                        {/* 送信ボタン */}
                        <Button variant='outlined' sx={{ marginTop: '20px' }}>
                            送信
                        </Button>
                    </Grid>
                </Box>
            </Container>
        </UserFrame>
    )
}

// このコンポーネントをエクスポートして他のファイルで利用可能にする
export default UserContactTemplate;
